import { makeVar } from '@apollo/client'
import classNames from 'classnames'
import { FC, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import styles from './Drawer.module.scss'

export interface DrawerContentProps {
    close: () => void
    opened: boolean
}

interface Props {
    direction: 'left' | 'right' | 'top'
    open: boolean
    fullHeight?: boolean
    fullWidth?: boolean
    backdrop?: boolean
    className?: string
    drawerContent: FC<DrawerContentProps>
}

export const drawerVar = makeVar<{ open: boolean }>({ open: false })

export default function Drawer({
    backdrop = true,
    open,
    fullHeight = true,
    fullWidth = false,
    direction = 'right',
    className,
    drawerContent: DrawerContent,
}: Props) {
    const [opened, setOpened] = useState<boolean>()

    useEffect(() => {
        setOpened(open)
        if (open) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.removeProperty('overflow')
        }
    }, [open])

    return (
        <>
            {createPortal(
                <>
                    <div
                        className={classNames(
                            styles.drawer,
                            opened ? styles.opened : styles.closed,
                            fullHeight ? styles.fullHeight : '',
                            fullWidth ? styles.fullWidth : '',
                            styles[direction],
                            className,
                        )}
                    >
                        <DrawerContent
                            opened={opened ?? false}
                            close={() => setOpened(false)}
                        />
                    </div>
                    <div
                        className={classNames(
                            backdrop ? styles.backdrop : '',
                            opened && backdrop ? styles.show : '',
                        )}
                    />
                </>,
                document.body,
            )}
        </>
    )
}
